module.exports = __webpack_public_path__ + "static/media/taobao-guide-background.d0fd778e.png";